import { createContext, ReactNode } from 'react'

interface IContentsModalContextData {
  setIsOpen: (isOpen: number) => void
  isOpen: boolean
}

export const ContentsModalContext = createContext<IContentsModalContextData>(
  {} as IContentsModalContextData,
)

export function ContentsModalProvider({
  children,
  setIsOpen,
  isOpen,
}: {
  children: ReactNode
} & IContentsModalContextData) {
  return (
    <ContentsModalContext.Provider value={{ setIsOpen, isOpen }}>
      {children}
    </ContentsModalContext.Provider>
  )
}
